
export default function ServiceProcess() {
  const steps = [
    {
      number: '01',
      title: 'Audit Sécurité',
      description: 'Analyse complète de vos besoins et évaluation des risques de votre site.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Devis Personnalisé',
      description: 'Proposition technique et commerciale adaptée à votre budget et vos exigences.',
      icon: 'ri-file-text-line'
    },
    {
      number: '03',
      title: 'Installation',
      description: 'Mise en place professionnelle de vos équipements par nos techniciens certifiés.',
      icon: 'ri-tools-line'
    },
    {
      number: '04',
      title: 'Formation & Support',
      description: 'Formation de vos équipes et support technique continu pour une utilisation optimale.',
      icon: 'ri-graduation-cap-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Notre <span className="text-red-600">Processus</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une approche méthodique pour garantir la réussite de votre projet sécurité
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-red-200 transform translate-x-4 z-0"></div>
              )}
              
              <div className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 text-center z-10">
                <div className="w-16 h-16 bg-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                
                <div className="absolute -top-4 -right-4 w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                  <span className="text-red-600 font-bold text-lg">{step.number}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
